import { ApiCustomFieldReference } from "@/types/custom-field.types.ts";

export function getEntityReferenceTitle(
  reference: Pick<ApiCustomFieldReference, "title" | "is_archived">,
  archivedLabel: string
): string {
  return reference.is_archived ? `${reference.title} (${archivedLabel})` : reference.title;
}
